import {
  SURVEY_VIEW_GET_FORM,
  SURVEY_VIEW_GET_FORM_SUCCESS,
  SURVEY_VIEW_GET_FORM_ERROR,
  SURVEY_UPT_PAGE_VISIBLE,
  GET_ANS,
  UPT_ANS,
  GET_ANS_SUCCESS,
  GET_ANS_ERROR,
  CLR_QUES_1,
  CLR_QUES_2,
  SURVEY_VIEW_SET_VALIDATION,
  SURVEY_VIEW_UNSET_VALIDATION,
  SURVEY_VIEW_SET_PAGE_TOUCH_VALIDATION,
  SET_DUP_CID,
  SURVEY_VIEW_LIVE_SCORE,
} from '../actions';

export const getSurveyView = () => ({
  type: SURVEY_VIEW_GET_FORM,
});

export const getSurveyViewSuccess = (items) => ({
  type: SURVEY_VIEW_GET_FORM_SUCCESS,
  payload: items,
});

export const getSurveyViewError = (error) => ({
  type: SURVEY_VIEW_GET_FORM_ERROR,
  payload: error,
});

export const uptPageVisi = (id, items) => ({
  type: SURVEY_UPT_PAGE_VISIBLE,
  payload: { id, items },
});

export const getAns = (survey) => ({
  type: GET_ANS,
  payload: survey,
});

export const getAnsSuccess = (items) => ({
  type: GET_ANS_SUCCESS,
  payload: items,
});

export const getAnsError = (error) => ({
  type: GET_ANS_ERROR,
  payload: error,
});

export const uptAnsForm = (items) => ({
  type: UPT_ANS,
  payload: items,
});

export const uptDupCid = (val) => ({
  type: SET_DUP_CID,
  payload: val,
});

export const clearAllQues = (start, end, survey, answer) => ({
  type: CLR_QUES_1,
  payload: {start,end,survey,answer},
});

export const clearSomeQues = (pi, start, end, survey, answer) => ({
  type: CLR_QUES_2,
  payload: {pi, start,end,survey, answer},
});

export const setValidation = (payload) => {
  return {
    type: SURVEY_VIEW_SET_VALIDATION,
    payload,
  }
};

export const unSetValidation = (payload) => {
  return {
    type: SURVEY_VIEW_UNSET_VALIDATION,
    payload,
  }
};

export const setPageTouchValidation = (payload) => {
  return {
    type: SURVEY_VIEW_SET_PAGE_TOUCH_VALIDATION,
    payload,
  }
};

export const setScoremode = (payload) => ({
  type: SURVEY_VIEW_LIVE_SCORE,
  payload
});
